import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
import {httpResource} from "@/resources/http.resource";
import {ICorpRequest} from "@/modules/Corps/interfaces/corp-request.interface";
import store from "@/store/store";
import {ICorpsStore} from "@/modules/Corps/interfaces/corps-store.interface";
import {IAppState} from "@/interfaces/app-state.interface";

class RequestCorp {
  async getCorpsList(payload: { filters: ICorpsStore.IFilters }) {
    let asyncAction = async () => {
      const action = ICorpRequest.Action.CorpsMake;
      const command = ICorpRequest.Command.Get;

      const params: any = {
        command,
        ...payload.filters,
      };
      const response = await httpResource.httpAction({ action, params });
      const corps: ICorp.IEntity[] = response.data.result.corps;
      return corps;
    }
    const response = await store.dispatch('defaultResourceAction', { asyncAction });
    return response.response as ICorp.IEntity[];
  }

  async getCorpInfo(payload: ICorpRequest.IPayloadGetCorp) {
    let asyncAction = async () => {
      const action = ICorpRequest.Action.CorpsMake;
      const params: any = {
        command: ICorpRequest.Command.Get,
        id: payload.corpId,
      };
      const response = await httpResource.httpAction({ action, params });
      const corpInfo: ICorp.IEntity = response.data.result.corps[0];
      return {
        ...corpInfo,
        inArchive: !corpInfo.enabled,
      };
    };
    const response = await store.dispatch('defaultResourceAction', { asyncAction });
    return response.response as ICorp.IEntity;
  }

  async createCorp(payload: ICorpRequest.IPayloadCreateCorp) {
    let asyncAction = async () => {
      const action = ICorpRequest.Action.CorpsMake;
      const params: any = {
        command: ICorpRequest.Command.Add,
        ...payload,
        enabled: true,
      };
      const response = await httpResource.httpAction({ action, params });
      return response.data.result.corps[0].id;
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async changeRefCode(payload: ICorpRequest.IPayloadChangeRefCode) {
    let asyncAction = async () => {
      const action = ICorpRequest.Action.CorpsMake;
      const params: any = {
        command: ICorpRequest.Command.ChangeRef,
        id: payload.corpId,
      };
      const response = await httpResource.httpAction({ action, params });
      return response.data.result.refCode;
    };
    const response = await store.dispatch('defaultResourceAction', { asyncAction });
    return response.response;
  }

  async updateCorpInfo(payload: ICorp.IEntity, createMode: boolean) {
    let asyncAction = async () => {
      const action = ICorpRequest.Action.CorpsMake;
      const params: any = {
        command: createMode ? ICorpRequest.Command.Add : ICorpRequest.Command.Update,
        ...payload,
        enabled: !payload.inArchive,
        fltOwnerCorpId: (store.state as IAppState).corps.filters?.fltOwnerCorpId,
      };
      return await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async changeCorp(payload: ICorpRequest.IPayloadChangeCorp) {
    let asyncAction = async () => {
      const action = ICorpRequest.Action.CorpsMake;
      const params: any = {
        command: ICorpRequest.Command.ChangeCorp,
        refCode: payload.refCode,
      };
      await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }
}

export const corpRequest = new RequestCorp();
